<template>
  <div class="captcha">
    <canvas ref="captchaCanvas" :width="width" :height="height" @click="refreshCaptcha"></canvas>
  </div>
</template>

<script>
export default {
  name: "Captcha",
  props: {
    width: {
      type: Number,
      default: 120,
    },
    height: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      captchaText: "",
    };
  },
  methods: {
    // 生成随机验证码
    generateCaptcha() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let captcha = "";
      for (let i = 0; i < 5; i++) {
        captcha += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captchaText = captcha;
    },
    getYam(){
      return this.captchaText
    },
    // 绘制验证码
    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext("2d");

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 绘制背景
      ctx.fillStyle = "#f3f3f3";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制验证码文本
      ctx.font = "30px Arial";
      ctx.fillStyle = "#333";
      ctx.fillText(this.captchaText, 20, 30);

      // 添加干扰线
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.strokeStyle = "#aaa";
        ctx.stroke();
      }

      // 添加噪点
      for (let i = 0; i < 30; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, 2 * Math.PI);
        ctx.fillStyle = "#666";
        ctx.fill();
      }
    },

    // 刷新验证码
    refreshCaptcha() {
      this.generateCaptcha();
      this.drawCaptcha();
      // this.$emit("update:captcha", this.captchaText); // 触发事件，更新验证码
    },
  },
  mounted() {
    this.refreshCaptcha();
  },
};
</script>

<style scoped>
.captcha {
  display: flex;
  align-items: center;
  gap: 10px;
}
canvas {
  border: 1px solid #ccc;
  cursor: pointer;
}
button {
  cursor: pointer;
}
</style>